import { createContext } from "react";
import { emptySupplier, ISupplier } from "../../../../types/supplier.types";

export type InitialStateType = {
  supplier: ISupplier
  saveSupplier: (supplierData: ISupplier) => Promise<{
    ok: boolean;
    data: ISupplier;
    errors: [{
      message: string;
      path: string[];
    }];
  }>
}

export const initialState: InitialStateType = {
  supplier: emptySupplier(),
  saveSupplier: () => Promise.reject({
    ok: false,
    data: emptySupplier(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}
export const SupplierDashboardContext = createContext(initialState)